module.exports = __webpack_public_path__ + "static/img/UTSG教室_3.f8801c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSG/UTSG教室_3.png
// module id = fDir
// module chunks = 0